import { TypedParam } from "./_Base";
import { ParamType } from "../poly/ParamType";
export class FolderParam extends TypedParam {
  static type() {
    return ParamType.FOLDER;
  }
  defaultValueSerialized() {
    return this._default_value;
  }
  rawInputSerialized() {
    return this._raw_input;
  }
  valueSerialized() {
    return this.value;
  }
  _copyValue(param) {
  }
  static areRawInputEqual(raw_input1, raw_input2) {
    return true;
  }
  static areValuesEqual(val1, val2) {
    return true;
  }
}
